/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Group_Add_MemberInputs */

const vi_customer_group_add_member = /** @type {(inputs: Customer_Group_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm khách hàng`)
};

/**

* @param {Customer_Group_Add_MemberInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_add_member = /** @type {((inputs?: Customer_Group_Add_MemberInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_Add_MemberInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_add_member(inputs)
});